import { tracking as barkTrackingLogEvent } from '@bark/bark-core';

export default function () {
	const {
		Bark: { api, apiVersionHeader, showFormErrorsBootstrap, USER },
	} = window;
	let formData = {
		bid: undefined,
		hired_seller: undefined,
		qvalue: undefined,
		qtype: undefined,
		reason: undefined,
		reason_other: undefined,
		noDisclosure: undefined,
		action: undefined,
	};

	// Not going to bother doing a zero index here because i have not done so for the question numbers;
	let activeQuestionNumber = 1;
	let previousQuestionNumber = 1;
	let hiredSomeone = false;

	const init = () => {
		bindListeners();
		getRepliesToProject();
		renderWhyNotOptions();
		formData.bid = getProjectId();
		hiredSomeone = $('#hired-someone').val() === '1';

		const url = new URL(window.location.href);
		const bookingId = url.searchParams.get('cbid');
		const bookingFeedback = url.searchParams.get('bbfb');
		url.searchParams.delete('fthx');
		url.searchParams.delete('cbid');
		url.searchParams.delete('bbfb');
		history.replaceState(history.state, '', url.href);

		function trackEmailFeeedback() {
			function getBookingFeedback() {
				switch (bookingFeedback) {
					case 'okh':
					case 'okc':
						return 'spoke';
					case 'nokb':
						return 'no_buyer_pickup';
					case 'noks':
						return 'no_seller_call';
					case 'na':
						return 'no_feedback';
					default:
						return undefined;
				}
			}

			barkTrackingLogEvent(
				'buyer_booking_callback_feedback_email',
				'Buyer-booking-call-feedback',
				{
					buyer_user_id: Bark.USER.userId,
					project_id: formData.bid,
					booking_id: bookingId,
					'feedback option': getBookingFeedback(),
				},
			);
		}

		bookingId && bookingFeedback && trackEmailFeeedback();
	};

	const bindListeners = () => {
		$('.js-next-question').on('click', (event) => {
			nextQuestion(event);
		});
		$('.js-prev-question').on('click', (event) => {
			prevQuestion(event);
		});
		$('#close-bark-form').on('focusin', '.inline-bark-q-radio-other', function () {
			$(this)
				.closest('.inline-bark-q-radio')
				.find('.inline-bark-radio')
				.prop('checked', true);
		});
		$('#no-disclosure').on('change', function () {
			toggleEstimateFormDisabled(this.checked);
		});
	};

	const toggleEstimateFormDisabled = (checked) => {
		$('.hired-estimate').attr('disabled', checked);
	};

	const submitCloseBark = (formData) => {
		toggleNextDisabled(true);
		toggleErrors(false);
		api(
			'/buyer/bark/close/',
			formData,
			(res) => {
				let { data } = res;
				toggleNextDisabled(false);
				if (formData.hired_seller > 0) {
					window.location = _l('/buyers/closed-project/' + getProjectIdHashed());
				} else {
					window.location = _l('/buyers/dashboard/?close-bark-confirm=1');
				}
			},
			(res) => {
				toggleErrors(_t('buyer_project_close-project:errors.save-feedback'));
				toggleNextDisabled(false);
			},
			'POST',
		);
	};

	const toggleBackText = (questionNumber) => {
		if (questionNumber <= 1) {
			$('.js-prev-question').text(_t('buyer_project_close-project:cancel-button'));
		} else {
			$('.js-prev-question').text(_t('buyer_project_close-project:back-button'));
		}
	};

	const toggleSubmitText = (questionNumber) => {
		if (questionNumber <= 1) {
			$('.js-next-question').text(_t('buyer_project_close-project:next-button'));
		} else {
			$('.js-next-question').text(_t('buyer_project_close-project:submit-button'));
		}
	};

	const prevQuestion = (event) => {
		if (activeQuestionNumber <= 1) {
			window.location.href = _l('/buyers/dashboard/');
		}
		activeQuestionNumber = previousQuestionNumber;

		renderQuestion(activeQuestionNumber);
	};

	const nextQuestion = () => {
		let { isValid, error, question } = validateAnswer(activeQuestionNumber);

		if (isValid) {
			let { type: questionType } = question;

			if (questionType === 'radio') {
				formData = { ...formData, [question.radioName]: question.optionChosen };

				if (question.radioName === 'reason') {
					formData['reason_other'] = question.otherReason;
				}
			}

			if (questionType === 'estimate') {
				let { quote, quoteType, noDisclosure } = question.answers;

				formData = { ...formData, qvalue: quote, qtype: quoteType, noDisclosure };
			}

			if (hiredSomeone) {
				formData = { ...formData, action: 'hired-someone' };
			}

			if (activeQuestionNumber > 1) {
				return submitCloseBark(formData);
			}

			previousQuestionNumber = activeQuestionNumber;

			if (formData.hired_seller === '-1') {
				const whyNotHiredQuestionNumber = 3;
				activeQuestionNumber = whyNotHiredQuestionNumber;
			} else {
				activeQuestionNumber++;
			}

			renderQuestion(activeQuestionNumber);
		}

		toggleErrors(error);
	};

	const renderQuestion = (questionNumber) => {
		toggleSubmitText(questionNumber);
		toggleBackText(questionNumber);
		toggleErrors(false);

		$('.question-title').addClass('d-none');
		$(`.title-question-${questionNumber}`).removeClass('d-none');
		$('.question').addClass('d-none');
		$(`.question-${questionNumber}`).removeClass('d-none');
	};

	const toggleErrors = (error) => {
		let $errorBox = $('.error-box');
		if (error) {
			$errorBox.text(error);
			$errorBox.removeClass('d-none');
		} else {
			$errorBox.addClass('d-none');
		}
	};

	const toggleNextDisabled = (disable) => {
		if (disable) {
			$('.js-next-question').addClass('disabled');
		} else {
			$('.js-next-question').removeClass('disabled');
		}
	};

	const validateAnswer = (questionNumber) => {
		if (questionNumber === 1) {
			return validateRadioQuestion('hired_seller');
		} else if (questionNumber === 2) {
			return validateEstimate();
		} else if (questionNumber === 3) {
			return validateRadioQuestion('reason');
		}
	};

	const validateEstimate = () => {
		const quote = +$('#close-bark-form .estimate-amount').val(),
			quoteType = $('#close-bark-form .estimate-type').val();
		let error = undefined;
		let noDisclosure = $('#no-disclosure').prop('checked');

		if (!quote && !noDisclosure) {
			error = _t('buyer_project_close-project:errors.amount');
		} else if (!quoteType && !noDisclosure) {
			error = _t('buyer_project_close-project:errors.price-type');
		}

		if (error) {
			return {
				isValid: false,
				error,
				question: { type: 'estimate', answers: { quote, quoteType, noDisclosure } },
			};
		}

		return {
			isValid: true,
			error: undefined,
			question: { type: 'estimate', answers: { quote, quoteType, noDisclosure } },
		};
	};

	const validateRadioQuestion = (radioName) => {
		let optionChosen = $(`input[name=${radioName}]:checked`, '#close-bark-form').val();
		let otherReason = $('.inline-bark-q-radio-other').first().val();

		if (typeof optionChosen === 'undefined') {
			return {
				isValid: false,
				error: _t('buyer_project_close-project:errors.select-option'),
				question: { type: 'radio', radioName, optionChosen, otherReason },
			};
		}

		if (optionChosen === 'other' && !otherReason) {
			return {
				isValid: false,
				error: _t('buyer_project_close-project:errors.enter-value-other'),
				question: { type: 'radio', radioName, optionChosen, otherReason },
			};
		}

		return {
			isValid: true,
			error: undefined,
			question: { type: 'radio', radioName, optionChosen, otherReason },
		};
	};

	const getRepliesToProject = () => {
		api(
			'buyer/bark/close/',
			{ bid: getProjectId() },
			(res) => {
				toggleLoading(true);
				let { data: responses } = res;

				let options = responses.map((response) => {
					let { company_name, seller_name, seller_profile_id } = response;

					const inputId = `seller-${seller_profile_id}`;
					const label = `${company_name} (${seller_name})`;
					const name = 'hired_seller';

					return { inputId, name, value: seller_profile_id, label };
				});

				renderRadioQuestion(options, '.hired-seller-list');
				toggleLoading(false);
				toggleShowSellerList(responses.length > 0);
				appendDefaultOptions();
			},
			(res) => {},
		);
	};

	const appendDefaultOptions = () => {
		let optionTemplate = Handlebars.compile($('#answer-radio-option').html());
		let name = 'hired_seller';

		let defaultOptions = [
			{
				inputId: 'seller-other',
				name,
				value: 0,
				label: _t('buyer_project_close-project:hire-options.not-on-bark'),
			},
			{
				inputId: 'seller-0',
				name,
				value: -1,
				label: _t('buyer_project_close-project:hire-options.did-not-hire'),
			},
		];

		if (hiredSomeone) {
			defaultOptions.pop();
		}

		defaultOptions.forEach((option) => {
			let optionHtml = optionTemplate(option);
			$('.default-options').append(optionHtml);
		});
	};

	const toggleShowSellerList = (show) => {
		if (show) {
			$('.hired-seller-list').removeClass('d-none');
		} else {
			$('.hired-seller-list').addClass('d-none');
		}
	};

	const toggleLoading = (show) => {
		if (show) {
			$('.js-loading').addClass('d-flex').removeClass('d-none');
		} else {
			$('.js-loading').addClass('d-none').removeClass('d-flex');
		}
	};

	const getProjectId = () => {
		return $('#project-id').val();
	};

	const getProjectIdHashed = () => {
		return $('#project-idh').val();
	};

	const getNumberOfQuestions = () => {
		return $('.question').length;
	};

	const renderRadioQuestion = (options, appendSelector) => {
		let optionTemplate = Handlebars.compile($('#answer-radio-option').html());

		options.forEach((option) => {
			let optionHtml = optionTemplate(option);
			$(appendSelector).append(optionHtml);
		});
	};

	const renderWhyNotOptions = () => {
		renderRadioQuestion(getWhyNotOptions(), '.why-not-option-list');
	};

	//This should obvi come from the api, but I don't have time and so there
	const getWhyNotOptions = () => {
		let name = 'reason';

		return [
			{
				inputId: 'why1',
				name,
				value: "I'm still deciding on who to hire",
				label: _t('buyer_project_close-project:why-not-hire-options.still-deciding'),
			},
			{
				inputId: 'why2',
				name,
				value: 'I decided to do it myself or a friend helped',
				label: _t('buyer_project_close-project:why-not-hire-options.do-it-myself'),
			},
			{
				inputId: 'why3',
				name,
				value: 'There was a change of plan',
				label: _t('buyer_project_close-project:why-not-hire-options.change-of-plan'),
			},
			{
				inputId: 'why4',
				name,
				value: "I'm putting the project on hold",
				label: _t('buyer_project_close-project:why-not-hire-options.project-on-hold'),
			},
			{
				inputId: 'why5',
				name,
				value: 'The quotes were not right for me',
				label: _t('buyer_project_close-project:why-not-hire-options.not-right'),
			},
			{
				inputId: 'why6',
				name,
				value: 'other',
				label: '',
				otherTextInput: true,
				otherName: 'reason_other',
			},
		];
	};

	init();
}
